import { applySipBulkResultsToComplexes } from "./applySipBulkResults";

export function createSipEditorDraft(row) {
  return {
    sip_number: String(row?.sip_number ?? ""),
    transfer_number: String(row?.transfer_number ?? ""),
    type: String(row?.type ?? ""),
    offerPrice: row?.offerPrice == null ? "" : String(row.offerPrice),
    status: row?.status !== false,
  };
}

export function buildSipEditorPatch(original, draft) {
  const errors = {};
  const patch = {};
  const sipNumber = String(draft.sip_number ?? "").trim() || null;
  const transferText = String(draft.transfer_number ?? "").trim();
  const type = String(draft.type ?? "").trim() || null;
  const transferNumber = transferText ? Number(transferText) : null;
  const offerPriceText = String(draft.offerPrice ?? "").trim();
  const offerPrice = offerPriceText ? Number(offerPriceText) : null;

  if (transferText && !Number.isInteger(transferNumber)) {
    errors.transfer_number = "Номер перевода должен быть целым числом";
  }
  if (offerPriceText && (!Number.isFinite(offerPrice) || offerPrice < 0)) errors.offerPrice = "Цена оффера должна быть неотрицательным числом";
  if (sipNumber !== (String(original.sip_number ?? "").trim() || null)) patch.sip_number = sipNumber;
  if (!errors.transfer_number && transferNumber !== (Number.isInteger(original.transfer_number) ? original.transfer_number : null)) {
    patch.transfer_number = transferNumber;
  }
  if (!errors.type && type !== (String(original.type ?? "").trim() || null)) patch.type = type;
  if (!errors.offerPrice && offerPrice !== (original.offerPrice ?? null)) patch.offerPrice = offerPrice;
  if (Boolean(draft.status) !== (original.status !== false)) patch.status = Boolean(draft.status);

  return { patch, errors, changedFieldCount: Object.keys(patch).length };
}

export function applyBulkEditResultsToComplexes(complexes, results) {
  return applySipBulkResultsToComplexes(complexes, results, (result) => result.client);
}
